import { useEffect, useState } from "react";
import { Database } from "lucide-react";
import { api } from "@/lib/api";

export function SourcesStrip() {
  const [providers, setProviders] = useState([]);

  useEffect(() => {
    api.get("/providers").then((r) => setProviders(r.data?.providers || [])).catch(() => {});
  }, []);

  if (providers.length === 0) return null;

  return (
    <div data-testid="sources-strip" className="flex flex-wrap items-center gap-x-3 gap-y-2 mt-5 pt-4 border-t border-[#232D42]/60">
      <span className="flex items-center gap-1.5 text-[11px] font-mono uppercase tracking-wider text-slate-500">
        <Database size={12} /> Powered by real data
      </span>
      {providers.map((p) => (
        <span key={p.id} data-testid={`source-${p.id}`}
          className="flex items-center gap-1.5 text-[11px] font-mono px-2 py-0.5 rounded"
          style={p.active ? { color: "#00E5A3", background: "#00E5A312" } : { color: "#64748B", background: "#64748B12" }}
          title={p.note}>
          <span className="h-1.5 w-1.5 rounded-full" style={{ background: p.active ? "#00E5A3" : "#475569" }} />
          {p.name}
          <span className="text-[9px] uppercase opacity-70">{p.mode}</span>
        </span>
      ))}
    </div>
  );
}
